export const LOGIN_PATH = '/iniciar-sesion';
export const ROOT_PAGE_PATH = '/';

export const EMPRESA_PATH = '/empresa';
export const CREAR_EMPRESA_PATH = '/crear-empresa';
export const EDITAR_EMPRESA_PATH = '/editar-empresa';
export const INFO_EMPRESA_PATH = '/info-empresa/:id';

export const USUARIO_PATH = '/usuario';
export const INFO_USUARIO_PATH = '/info-usuario/:id';
export const PRIVILEGIOS_USUARIO_PATH = '/usuario/:id/privilegios';

export const PROYECTO_PATH = '/proyecto';
export const INFO_PROYECTO_PATH = '/info-proyecto/:id';

export const ELEMENTO_PATH = '/elemento';
export const INFO_ELEMENTO_PATH = '/info-elemento/:id';

export const SENSOR_PATH = '/sensor';
export const INFO_SENSOR_PATH = '/info-sensor/:id';
export const EDITAR_SENSOR_PATH = '/sensores/editar/:id';

export const TARJETA_PATH = '/tarjeta';
export const INFO_TARJETA_PATH = '/info-tarjeta/:id';
export const EDITAR_TARJETA_PATH = '/tarjetas/editar/:id';

export const GRAFICA_PATH = '/grafica';
export const INFO_GRAFICA_PATH = '/info-grafica/:id';
export const CREAR_GRAFICA_PATH = '/crear-grafica';

export const RESET_PASS_PATH = '/restablecer-password';
export const NUEVA_CONTRASEÑA_PATH = '/nuevo-password/:token';

export const REPORTES_PATH = '/reporte';

export const LOGS_PATH = '/logs';

export const DASHBOARD_V2_PATH = '/dashboard-personalizado';
export const DASHBOARD_V1_PATH = '/dashboard-clasico';
